module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ts-messagebox-wrapper"
  }, [_c('transition', {
    attrs: {
      "name": "messagebox-fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.value),
      expression: "value"
    }],
    staticClass: "ts-messagebox"
  }, [(_vm.title !== '') ? _c('div', {
    staticClass: "ts-messagebox-header"
  }, [_c('div', {
    staticClass: "ts-messagebox-title onepx-b"
  }, [_vm._v("\r\n          " + _vm._s(_vm.title) + "\r\n        ")]), _vm._v(" "), (_vm.message !== '') ? _c('div', {
    staticClass: "ts-messagebox-content"
  }, [_c('div', {
    staticClass: "ts-messagebox-message",
    domProps: {
      "innerHTML": _vm._s(_vm.message)
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "ts-messagebox-btns"
  }, [_c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showCancelButton),
      expression: "showCancelButton"
    }],
    staticClass: "ts-messagebox-btn ts-messagebox-cancel",
    class: _vm.cancelButtonClass,
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        _vm.handleAction('cancel')
      }
    }
  }, [_vm._v("\r\n        " + _vm._s(_vm.cancelButtonText) + "\r\n        ")]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showConfirmButton),
      expression: "showConfirmButton"
    }],
    staticClass: "ts-messagebox-btn ts-messagebox-confirm",
    class: _vm.confirmButtonClass,
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        _vm.handleAction('confirm')
      }
    }
  }, [_vm._v("\r\n        " + _vm._s(_vm.confirmButtonText) + "\r\n        ")])])]) : _vm._e()])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-27f5865c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Components/common/messagebox/messagebox.vue
// module id = 810
// module chunks = 39